<div
	class="users-register-container"
	*ngIf="
		!isLoadingRegisterBaseForm &&
		!isLoadingRegisterEnduserForm &&
		!isLoadingRegisterAnalystForm &&
		!isLoadingUserData &&
		!isLoadingLogs &&
		!isLoadingPermissions
	">
	<ng-container *ngIf="view === 'search'">
		<div class="content-col-header">
			<span class="tab selected">{{ labels.lbl_buscar_usuarios }}</span>
		</div>
		<div class="content-col no-stretch">
			<cpi-generic-form-gen [columns]="1" [labels]="labels" [setGenericForm]="searchForm"> </cpi-generic-form-gen>

			<div class="button-container">
				<div class="button" (click)="view = 'register'">{{ labels.lbl_criar_novo_usuario }}</div>
				<div class="button" (click)="searchUser()">
					<span>{{ labels.lbl_geral_buscar }}</span>
					<cpi-dot-bounce-loading-effect [color]="'var(--const-white)'" *ngIf="isLoadingSearch"></cpi-dot-bounce-loading-effect>
				</div>
			</div>

			<cpi-input-with-autocomplete
				[availableOptions]="userListIAC"
				[minInputLength]="0"
				[placeholder]="labels.lbl_geral_usuarios_encontrados"
				(onValueChange)="getUserData($event)"
				*ngIf="userListIAC?.length > 0">
			</cpi-input-with-autocomplete>
		</div>
	</ng-container>

	<ng-container *ngIf="view === 'register'">
		<div class="content-col-header">
			<span class="tab" [ngClass]="{ selected: selectedTab === 'registerUser' }" (click)="selectedTab = 'registerUser'">{{
				labels.lbl_geral_usuario
			}}</span>
			<span class="tab" [ngClass]="{ selected: selectedTab === 'registerEnduser' }" (click)="selectedTab = 'registerEnduser'">{{
				labels.lbl_chamado_enduser
			}}</span>
			<span class="tab" [ngClass]="{ selected: selectedTab === 'registerAnalyst' }" (click)="selectedTab = 'registerAnalyst'">{{
				labels.lbl_geral_analista
			}}</span>
			<span
				class="tab"
				[ngClass]="{ selected: selectedTab === 'permissions' }"
				(click)="selectedTab = 'permissions'"
				*ngIf="selectedUser.id !== '' && ProfileService.userData().usertype === 'analyst.manager.administrator'"
				>{{ labels.lbl_cadastro_permissoes }}</span
			>
			<span class="tab" [ngClass]="{ selected: selectedTab === 'logs' }" (click)="selectedTab = 'logs'" *ngIf="selectedUser.id !== ''"
				>Logs</span
			>
		</div>

		<div class="content-col" [ngStyle]="{ visibility: selectedTab !== 'registerUser' ? 'hidden' : 'unset' }">
			<cpi-generic-form-gen
				[columns]="1"
				[labels]="labels"
				[setGenericForm]="registerBaseForm"
				[boldLabel]="false"
				(valueTap)="formatFieldsOnChange()">
			</cpi-generic-form-gen>

			<div class="button-container">
				<div class="button" [ngClass]="{ disabled: isRegisteringUser }" (click)="createUser()" *ngIf="selectedUser.id === ''">
					{{ labels.lbl_geral_registrar }}
					<cpi-dot-bounce-loading-effect [color]="'var(--const-white)'" *ngIf="isRegisteringUser"></cpi-dot-bounce-loading-effect>
				</div>
				<div class="button" [ngClass]="{ disabled: isRegisteringUser }" (click)="updateUser()" *ngIf="selectedUser.id !== ''">
					{{ labels.lbl_geral_atualizar }}
					<cpi-dot-bounce-loading-effect [color]="'var(--const-white)'" *ngIf="isRegisteringUser"></cpi-dot-bounce-loading-effect>
				</div>
			</div>
		</div>

		<div class="content-col" [ngStyle]="{ visibility: selectedTab !== 'registerEnduser' ? 'hidden' : 'unset' }">
			<div class="dotted-input-container">
				<span>{{ labels.lbl_geral_ativar }} {{ labels.lbl_chamado_enduser }}</span>
				<cpi-checkbox
					[value]="enduser_active"
					(oValue)="enduser_active = $event"
					[innerText]="enduser_active ? labels.lbl_geral_sim : labels.lbl_geral_nao">
				</cpi-checkbox>
			</div>

			<cpi-generic-form-gen
				[columns]="1"
				[labels]="labels"
				[setGenericForm]="registerEnduserForm"
				[boldLabel]="false"
				*ngIf="enduser_active">
			</cpi-generic-form-gen>

			<div class="button-container">
				<div class="button" [ngClass]="{ disabled: isRegisteringUser }" (click)="createUser()" *ngIf="selectedUser.id === ''">
					{{ labels.lbl_geral_registrar }}
					<cpi-dot-bounce-loading-effect [color]="'var(--const-white)'" *ngIf="isRegisteringUser"></cpi-dot-bounce-loading-effect>
				</div>
				<div class="button" [ngClass]="{ disabled: isRegisteringUser }" (click)="updateUser()" *ngIf="selectedUser.id !== ''">
					{{ labels.lbl_geral_atualizar }}
					<cpi-dot-bounce-loading-effect [color]="'var(--const-white)'" *ngIf="isRegisteringUser"></cpi-dot-bounce-loading-effect>
				</div>
			</div>
		</div>

		<div class="content-col" [ngStyle]="{ visibility: selectedTab !== 'registerAnalyst' ? 'hidden' : 'unset' }">
			<div class="dotted-input-container">
				<span>{{ labels.lbl_geral_ativar }} {{ labels.lbl_geral_analista }}</span>
				<cpi-checkbox
					[value]="analyst_active"
					(oValue)="analyst_active = $event"
					[innerText]="analyst_active ? labels.lbl_geral_sim : labels.lbl_geral_nao">
				</cpi-checkbox>
			</div>

			<cpi-generic-form-gen
				[columns]="1"
				[labels]="labels"
				[setGenericForm]="registerAnalystForm"
				[boldLabel]="false"
				*ngIf="analyst_active">
			</cpi-generic-form-gen>

			<div class="button-container">
				<div class="button" [ngClass]="{ disabled: isRegisteringUser }" (click)="createUser()" *ngIf="selectedUser.id === ''">
					{{ labels.lbl_geral_registrar }}
					<cpi-dot-bounce-loading-effect [color]="'var(--const-white)'" *ngIf="isRegisteringUser"></cpi-dot-bounce-loading-effect>
				</div>
				<div class="button" [ngClass]="{ disabled: isRegisteringUser }" (click)="updateUser()" *ngIf="selectedUser.id !== ''">
					{{ labels.lbl_geral_atualizar }}
					<cpi-dot-bounce-loading-effect [color]="'var(--const-white)'" *ngIf="isRegisteringUser"></cpi-dot-bounce-loading-effect>
				</div>
			</div>
		</div>

		<div class="content-col" [ngStyle]="{ visibility: selectedTab !== 'permissions' ? 'hidden' : 'unset' }">
			<div *ngIf="analyst_active">
				<span class="table-header">{{ labels.lbl_chamado_enduser }}</span>
				<div class="permission-container">
					<div class="line">
						<div class="header">
							<input
								[placeholder]="labels.lbl_cadastro_permissoes"
								[value]="enduserPermissionSort.filterPermission"
								(input)="enduserPermissionSort.filterPermission = $event.target.value" />
							<span
								[ngClass]="{ selected: enduserPermissionSort.sortName === 'permission' }"
								(click)="
									enduserPermissionSort.sortName === 'permission'
										? (enduserPermissionSort.sortOrder[0] = !enduserPermissionSort.sortOrder[0])
										: (enduserPermissionSort.sortName = 'permission');
									sortPermissions('enduser')
								">
								<fa-icon [ngClass]="{ sortUp: enduserPermissionSort.sortOrder[0] }" [icon]="icons.faSortDown"></fa-icon>
							</span>
						</div>
						<div class="header">
							<input
								[placeholder]="labels.lbl_geral_descricao"
								[value]="enduserPermissionSort.filterDescription"
								(input)="enduserPermissionSort.filterDescription = $event.target.value" />
							<span
								[ngClass]="{ selected: enduserPermissionSort.sortName === 'description' }"
								(click)="
									enduserPermissionSort.sortName === 'description'
										? (enduserPermissionSort.sortOrder[1] = !enduserPermissionSort.sortOrder[1])
										: (enduserPermissionSort.sortName = 'description');
									sortPermissions('enduser')
								">
								<fa-icon [ngClass]="{ sortUp: enduserPermissionSort.sortOrder[1] }" [icon]="icons.faSortDown"></fa-icon>
							</span>
						</div>
						<div class="header">
							<span>{{ labels.lbl_geral_ativo }}</span>
							<span
								[ngClass]="{ selected: enduserPermissionSort.sortName === 'active' }"
								(click)="
									enduserPermissionSort.sortName === 'active'
										? (enduserPermissionSort.sortOrder[2] = !enduserPermissionSort.sortOrder[2])
										: (enduserPermissionSort.sortName = 'active');
									sortPermissions('enduser')
								">
								<fa-icon [ngClass]="{ sortUp: enduserPermissionSort.sortOrder[2] }" [icon]="icons.faSortDown"></fa-icon>
							</span>
						</div>
					</div>
					<div class="line" *ngFor="let permission of userPermissionsKeys | callback: enduserPermissionFilterCallback">
						<span [title]="permission">{{ permission }}</span>
						<span [title]="userPermissions[permission].description">{{ userPermissions[permission].description }}</span>
						<span
							><cpi-three-state-toggle-switch
								[disableMidState]="false"
								[setState]="userPermissions[permission].allowed_on_enduser"
								(getState)="userPermissions[permission].allowed_on_enduser = $event"></cpi-three-state-toggle-switch
						></span>
					</div>
				</div>
			</div>

			<div>
				<span class="table-header">{{ labels.lbl_geral_analista }}</span>
				<div class="permission-container">
					<div class="line">
						<div class="header">
							<input
								[placeholder]="labels.lbl_cadastro_permissoes"
								[value]="analystPermissionSort.filterPermission"
								(input)="analystPermissionSort.filterPermission = $event.target.value" />
							<span
								[ngClass]="{ selected: analystPermissionSort.sortName === 'permission' }"
								(click)="
									analystPermissionSort.sortName === 'permission'
										? (analystPermissionSort.sortOrder[0] = !analystPermissionSort.sortOrder[0])
										: (analystPermissionSort.sortName = 'permission');
									sortPermissions('analyst')
								">
								<fa-icon [ngClass]="{ sortUp: analystPermissionSort.sortOrder[0] }" [icon]="icons.faSortDown"></fa-icon>
							</span>
						</div>
						<div class="header">
							<input
								[placeholder]="labels.lbl_geral_descricao"
								[value]="analystPermissionSort.filterDescription"
								(input)="analystPermissionSort.filterDescription = $event.target.value" />
							<span
								[ngClass]="{ selected: analystPermissionSort.sortName === 'description' }"
								(click)="
									analystPermissionSort.sortName === 'description'
										? (analystPermissionSort.sortOrder[1] = !analystPermissionSort.sortOrder[1])
										: (analystPermissionSort.sortName = 'description');
									sortPermissions('analyst')
								">
								<fa-icon [ngClass]="{ sortUp: analystPermissionSort.sortOrder[1] }" [icon]="icons.faSortDown"></fa-icon>
							</span>
						</div>
						<div class="header">
							<span>{{ labels.lbl_geral_ativo }}</span>
							<span
								[ngClass]="{ selected: analystPermissionSort.sortName === 'active' }"
								(click)="
									analystPermissionSort.sortName === 'active'
										? (analystPermissionSort.sortOrder[2] = !analystPermissionSort.sortOrder[2])
										: (analystPermissionSort.sortName = 'active');
									sortPermissions('analyst')
								">
								<fa-icon [ngClass]="{ sortUp: analystPermissionSort.sortOrder[2] }" [icon]="icons.faSortDown"></fa-icon>
							</span>
						</div>
					</div>
					<div class="line" *ngFor="let permission of userPermissionsKeys | callback: analystPermissionFilterCallback">
						<span [title]="permission">{{ permission }}</span>
						<span [title]="userPermissions[permission].description">{{ userPermissions[permission].description }}</span>
						<span
							><cpi-three-state-toggle-switch
								[disableMidState]="false"
								[setState]="userPermissions[permission].allowed_on_analyst"
								(getState)="userPermissions[permission].allowed_on_analyst = $event"></cpi-three-state-toggle-switch
						></span>
					</div>
				</div>
			</div>

			<div class="button-container">
				<div class="button" [ngClass]="{ disabled: isRegisteringUser }" (click)="updatePermissions()">
					{{ labels.lbl_geral_atualizar }} {{ labels.lbl_cadastro_permissoes }}
					<cpi-dot-bounce-loading-effect [color]="'var(--const-white)'" *ngIf="isRegisteringUser"></cpi-dot-bounce-loading-effect>
				</div>
			</div>
		</div>

		<div class="content-col" [ngStyle]="{ visibility: selectedTab !== 'logs' ? 'hidden' : 'unset' }">
			<div class="log" *ngFor="let logs of userLogs">
				{{ logs.log_date | date: 'dd/MM/yyyy h:mm a' : 'pt-BR' }} - {{ labels.lbl_alterado_por }} : {{ logs.updatedBy }}
				<br />
				<div [innerHTML]="logs.notes"></div>
			</div>
			<div class="log" *ngIf="userLogs.length === 0">
				{{ labels.lbl_security_nenhum_registro }}
			</div>
		</div>
	</ng-container>
</div>

<cpi-dot-bounce-loading-effect
	[color]="'var(--primary-color-1)'"
	*ngIf="
		isLoadingRegisterBaseForm ||
		isLoadingRegisterEnduserForm ||
		isLoadingRegisterAnalystForm ||
		isLoadingUserData ||
		isLoadingLogs ||
		isLoadingPermissions
	"></cpi-dot-bounce-loading-effect>
